export const parseFacilitiesHotel = (hotel: any) => {
  return (hotel.facilities || []).reduce((obj: any, facility: any) => {
    if (!obj[facility.propertyGroupDescription]) {
      obj[facility.propertyGroupDescription] = [facility]
    } else {
      obj[facility.propertyGroupDescription].push(facility)
    }
    return obj
  }, {} as any)
}